export default "__VITE_ASSET__DN2Jk$51__"